var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.311 16.606l14.269-5.351c0.262-0.105 0.42-0.341 0.42-0.603s-0.157-0.525-0.42-0.603l-14.689-5.508c-0.21-0.079-0.42-0.052-0.603 0.079s-0.289 0.315-0.289 0.551v21.797h1.311c0 0 0-10.361 0-10.361z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityFlag);
export default __webpack_public_path__ + "static/media/unity_flag.51bde948f49d6d78d923acce99012510.svg";
export { ForwardRef as ReactComponent };